import { createGlobalStyle } from 'styled-components';

export const TuningShopGlobalStyles = createGlobalStyle`
	.drag-image {
		position: absolute;
		top: -1000px;
		left: -1000px;
		border-radius: 5px;
		box-sizing: border-box;
		border: 1px solid rgba(255, 255, 255, 1);
	}

	.drag-image-icon {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		object-fit: contain;
	}
`;
